<template>
  <div class="gmf-mini-top-comment-wrap gmf-context" v-if="hasContent">
    <Avatar :customer="topComment.author" />
    <div class="gmf-mini-top-comment-body">
      <div class="gmf-mini-top-comment-name" v-text="topComment.author.firstName"></div>
      <div class="gmf-mini-top-comment-text gmf-text-small" v-text="topComment.content.text" />
    </div>
  </div>
</template>

<style>
.gmf-mini-top-review {
  width: 100%;
}
.gmf-mini-top-comment-wrap {
  display: flex;
  gap: var(--gmf-p-3);
  width: 100%;
  height: 48px;
}
.gmf-mini-top-comment-wrap .gmf-avatar {
    width: 32px;
    height: 32px;
    align-self: center;
    flex-shrink: 0;
}
.gmf-mini-top-comment-body {
  background: var(--gmf-col-lightgray);
  border-radius: var(--gmf-rounding);
  flex-grow: 1;
  padding: var(--gmf-p-2) var(--gmf-p-3);
  height: 100%;
  width: 0;
  max-width: 100%;

  justify-content: center;
  display: flex;
  flex-direction: column;

  position: relative;
}
.gmf-mini-top-comment-body:before {
  display: block;
  content: "";
  background: inherit;
  width: 20px;
  height: 20px;
  position: absolute;
  left: -10px;
  transform: rotate(45deg);
}
.gmf-mini-top-comment-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
  width: 100%;
}
.gmf-context .gmf-mini-top-comment-name {
  font-size: var(--gmf-text-small-font-size);
  font-weight: bold;
  font-family: var(--gmf-header-font);
  z-index: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
</style>

<script>
import state from '@/state';
import Avatar from '@/components/Avatar';
const t = state.t.prefix('comments');

import getTopComment from './getTopComment';

export default {
  props: ['productId'],
  data () {
    return {
      state,
      topComment: null,
    };
  },
  components: {
    Avatar,
  },
  computed: {
    hasContent() {
      return this.topComment && this.topComment.content && this.topComment.content.text;
    },
    description () {
      if (this.topComment.type.name === 'product_review') {
        return t('top_review');
      }
      if (this.topComment.type.name === 'product_hype') {
        return t('top_hype');
      }
      return t('top_hype');
    },
  },
  async mounted () {
    const res = await getTopComment(this.productId);
    if (res) {
      this.topComment = res;
    }
  },
};

</script>
